import PropTypes from "prop-types";
import "../styles/components/Pokemon.scss";

const Pokemon = (props) => {

  const renderTypes = () => {
    return props.item.types.map((type, index) => {
      switch (type) {
        case "fire":
          return <li className="pokemon__type fire" key={index}>{type}</li>;
        case "water":
          return <li className="pokemon__type water" key={index}>{type}</li>;
        case "grass":
          return <li className="pokemon__type grass" key={index}>{type}</li>;
        case "poison":
          return <li className="pokemon__type poison" key={index}>{type}</li>;
        case "flying":
          return <li className="pokemon__type flying" key={index}>{type}</li>;
        case "bug":
          return <li className="pokemon__type bug" key={index}>{type}</li>;
        case "electric":
          return <li className="pokemon__type electric" key={index}>{type}</li>;
        case "dark":
          return <li className="pokemon__type dark" key={index}>{type}</li>;
        case "dragon":
          return <li className="pokemon__type dragon" key={index}>{type}</li>;
        case "fairy":
          return <li className="pokemon__type fairy" key={index}>{type}</li>;
        case "fighting":
          return <li className="pokemon__type fighting" key={index}>{type}</li>;
        case "ice":
          return <li className="pokemon__type ice" key={index}>{type}</li>;
        case "ground":
          return <li className="pokemon__type ground" key={index}>{type}</li>;
        case "steel":
          return <li className="pokemon__type steel" key={index}>{type}</li>;
        case "normal":
          return <li className="pokemon__type normal" key={index}>{type}</li>;
        case "rock":
          return <li className="pokemon__type rock" key={index}>{type}</li>;
        case "psychic":
          return <li className="pokemon__type psychic" key={index}>{type}</li>;
        case "ghost":
          return <li className="pokemon__type ghost" key={index}>{type}</li>;
        default:
          return <li className="pokemon__type" key={index}>{type}</li>;
      };
    });
  };

  return (
    <>
      <article className="pokemon__item">
        <img
          className="pokemon__img"
          src={props.item.url}
          alt={props.item.name}
        />
        <p className="pokemon__name">
          <label className="pokemon__label">Name:</label>
          {props.item.name}
        </p>
        <p className="pokemon__name">
          <label className="pokemon__label">Evolution:</label>
          {props.item.evolution}
        </p>
        <p className="pokemon__name">
          <label className="pokemon__label">Types:</label>
        </p>
        <ul className="pokemon__types">{renderTypes()}</ul>
      </article>
    </>
  );
};

Pokemon.propTypes = {
  item: PropTypes.exact({
    name: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    types: PropTypes.array.isRequired,
    evolution: PropTypes.string,
    url: PropTypes.string.isRequired,
  }),
};

export default Pokemon;
